import { apiPost } from '@/lib/http/client';

import type {
  ActiveCampaignConnectRequest,
  ActiveCampaignConnectResponse,
  ActiveCampaignDisconnectResponse,
} from '../types';

export async function connectActiveCampaign(
  orgId: number | string,
  body: ActiveCampaignConnectRequest
): Promise<ActiveCampaignConnectResponse> {
  return apiPost<ActiveCampaignConnectResponse>(
    `/api/orgs/${orgId}/activecampaign/connect/`,
    body
  );
}

export async function disconnectActiveCampaign(
  orgId: number | string
): Promise<ActiveCampaignDisconnectResponse> {
  return apiPost<ActiveCampaignDisconnectResponse>(
    `/api/orgs/${orgId}/activecampaign/disconnect/`,
    {}
  );
}
